import type { ComponentDefinition } from "../types";

export const DC_BREAKERS: ComponentDefinition[] = [{
  // Minn Kota MKR-27 installation instructions 2377114 Rev A (09/22), pp.1–3:
  // https://johnsonoutdoors.widen.net/content/zbs8lpkdyv/pdf/MKR-27-60A-Circuit-Breaker-2377114ra.pdf
  // 60 A; 12/24/36/48 V nominal systems. BAT LINE must face the battery.
  // The manual/product page do not publish AIC or absolute maximum voltage.
  id: "breaker-minn-kota-mkr27",
  name: "Minn Kota MKR-27 DC Circuit Breaker 60A",
  shortName: "MKR-27 · 60A",
  subtitle: "Manual-reset DC circuit breaker",
  category: "distribution",
  manufacturer: "Minn Kota",
  model: "MKR-27 / 1865115",
  image: "breaker-minn-kota-mkr27.webp",
  width: 190,
  height: 120,
  terminals: [
    { id: "line", label: "BAT LINE", polarity: "positive", direction: "input", maxAmp: 60, side: "left", offset: .5 },
    { id: "load", label: "AUX LOAD", polarity: "positive", direction: "output", maxAmp: 60, side: "right", offset: .5 },
  ],
  compatibleVoltages: [12, 24, 36, 48],
  dcBreaker: { inputTerminalId: "line", outputTerminalId: "load", ratingA: 60 },
  // Contacts are user-controlled. Trip timing is not simulated.
  simulateStates: { default: "on", options: [
    { id: "on", label: "On", intraLinks: [["line", "load"]] },
    { id: "off", label: "Off", ampOverride: 0, intraLinks: [] },
    { id: "tripped", label: "Tripped", ampOverride: 0, intraLinks: [] },
  ] },
}];
